import { apiAgent } from "../../../axiosConfig"

export const subscribeApi = (data) => {    
    return apiAgent({
        method: 'post',
        url: '/outbound_mail/subscribe',
        data: data
    })
}